var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHair1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 111,
    viewBox: "0 0 128 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 110.912V80.8009C0 57.6011 9.96717 36.2357 17.2134 32.8691C49.5 17.8691 77 17.8691 111.257 33.3007C120.224 37.3403 128 66.8007 128 80.8009V110.912C126.847 110.067 125.503 109.438 123.948 109.065C123.983 107.718 124 106.355 124 104.979C124 58.5962 104.169 33.6725 64 33.6725C23.8312 33.6725 4 58.5962 4 104.979C4 106.355 4.01747 107.718 4.05241 109.065C2.49732 109.438 1.15329 110.067 0 110.912Z",
    className: "Hair"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.6084 40.6662C81.0702 45.8326 47.787 46.1805 33.0652 40.6662C27.515 38.5872 44.502 27.6725 64.3458 27.6725C75.95 27.6725 101.176 37.5477 93.6084 40.6662Z",
    className: "Hair"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8175 41.6584C91.0345 29.6476 93.5332 16.5257 85.688 7.14927C84.9791 6.30211 83.6889 6.31833 82.9081 7.09967C63.2289 26.7938 63.0132 27.6561 77.0113 41.683C77.7915 42.4648 79.0636 42.4656 79.8175 41.6584Z",
    className: "Hair"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2119 39.5796C54.6093 29.2624 55.9298 17.3466 48.0303 8.14111C47.3109 7.30286 46.0271 7.31294 45.2466 8.09446C28.5522 24.809 28.4683 25.6432 42.4139 39.6134C43.1942 40.3951 44.4681 40.3962 45.2119 39.5796Z",
    className: "Hair"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.0027 38.6263C91.8472 38.072 99.8534 32.5569 100.886 23.669C101.014 22.5718 100.102 21.6722 98.997 21.6729C78.8008 21.6869 78.0302 22.1381 78.0011 36.6622C77.9989 37.7668 78.8993 38.6779 80.0027 38.6263Z",
    className: "Hair"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1546 40.337C74.2907 29.7923 81.4186 15.1545 74.9711 1.77062C74.4918 0.775502 73.2364 0.460483 72.2799 1.01302C42.8488 18.0152 42.4243 18.7911 54.4311 39.6197C54.9827 40.5767 56.2139 40.9159 57.1546 40.337Z",
    className: "Hair"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHair1);
export default __webpack_public_path__ + "static/media/Hair 1.f6e5229d7aedbce31b6565693d7918e6.svg";
export { ForwardRef as ReactComponent };